// extracted by mini-css-extract-plugin
export default {"title":"FilesSection_title__-MZgY","icon":"FilesSection_icon__XTudF","files":"FilesSection_files__3RoGJ","noFiles":"FilesSection_noFiles__+XYe2"};